<template>
  <div class="strip">
    <div class="columns is-desktop">
      <div class="column has-text-right" />
      <div class="column is-half-desktop is-half-tablet has-text-right bg-blue">
        <h2 class="subtitle is-size-4-mobile is-marginless is-italic has-text-centered-mobile">
          <b>{{ result }}</b>
        </h2>
        <p class="desc is-size-4-widescreen is-size-5 has-text-centered-mobile">
          {{ description }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
const resultDetails = {
  Event: {
    imageName: "ev",
    desc:
      "As the Runner of the event, our job is to approach the capital market experts and arrange the capital market seminar and investment training."
  },
  "Conference Programming": {
    imageName: "cp",
    desc:
      "As the think tank of ICMSS, we conduct the international equity research conference and cooperate with capital market experts."
  },
  "Public Relations": {
    imageName: "pr",
    desc:
      "As the face of ICMSS, our job is to build and maintain a good relationship with the public and stakeholders through various online and offline channels."
  },
  "Marketing Communications": {
    imageName: "mc",
    desc:
      "As the visual powerhouse of ICMSS, we build public awareness through media partnership and graphic communication."
  },
  "Corporate Relations": {
    imageName: "cr",
    desc:
      "As the main source of ICMSS' funding, we deal with corporates and build mutually beneficial partnerships with them."
  },
  Operations: {
    imageName: "op",
    desc:
      "We keep ICMSS running smoothly by providing the most effective and efficient accomodation for each and every activity during the event."
  },
  Logistics: {
    imageName: "lg",
    desc:
      "Our job is to provide nourishments for delegates and committee alike during the event by building partnerships with F&B companies."
  },
  "Delegate Relations": {
    imageName: "dr",
    desc:
      "As the connecting bridge between the committee & delegates, we are responsible for all liaison activities and in providing a memorable experience for all national and international delegates."
  }
};

export default {
  name: "ResultStrip",
  props: {
    result: String
  },
  computed: {
    description() {
      return resultDetails[this.result].desc;
    }
  }
};
</script>

<style scoped>
h2,
p,
b {
  font-family: "Montserrat", sans-serif !important;
}

.strip {
  position: absolute;
  width: 100vw;
  background: transparent;
  left: 50%;
  transform: translateX(-50%);
  margin-top: 50px;
  /* transition: 0.2s all; */
  animation: fly-in 0.3s ease-in-out;
  animation-fill-mode: both;
}

.columns {
  margin: 0 !important;
}

.column {
  padding: 48px !important;
  height: 100%;
  min-height: 52vh;
  display: flex;
  flex-flow: column;
  justify-content: center;
}

.desc {
  padding: 32px 0;
}

@keyframes fly-in {
  from {
    transform: translateY(50px) translateX(-50%);
    opacity: 0.5;
  }
  to {
    transform: translateX(-50%);
    opacity: 1;
  }
}

@media screen and (max-width: 991px) {
  .column {
    min-height: 50vh;
    padding: 36px !important;
  }

  .strip {
    height: auto;
    position: relative;
    width: initial;
    margin-top: 24px;
  }
}

@media screen and (max-width: 767px) {
  .column {
    min-height: 20vh;
  }
}

.bg-blue {
  background-color: transparent;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center top;
  background-image: url("../assets/result-kanan.png");
}
</style>
